export default "__VITE_ASSET__a4420e37__"